import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'
import { AlertProvider } from '@/components/alerts/AlertProvider/index.ts'
import { wagmiAdapter } from '@/services/wallet/reown.config.ts'

const queryClient = new QueryClient()

interface AppProvidersProps {
  children: ReactNode
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AlertProvider>{children}</AlertProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </WagmiProvider>
  )
}
